import Cookies from "js-cookie";

export default [
    {
        path: '/',
        name: 'default',
        meta: {
            adminRequired: true,
            lmsRequired: true,
            userRequired: true,
            authRequired: true,
        },
        component: () => import('./views/dashboards/default'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./views/account/login'),
        meta: {
            /*adminRequired: true,
            lmsRequired: true,
            userRequired: true,*/

            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (Cookies.get("token")) {
                    // Redirect to the home page instead
                    next({name: "default"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/logout",
        name: "logout",
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true,
            userRequired: true,

            async beforeResolve(routeTo, routeFrom, next) {
                //await api.delete(`${process.env.VUE_APP_API_ENDPOINT}/auth/logout`)
                Cookies.remove("token");
                Cookies.remove('user');
                const authRequiredOnPreviousRoute = routeFrom.matched.some((route) => {
                        route.push("/login")
                    }
                );
                // Navigate back to previous page, or home as a fallback
                next(
                    authRequiredOnPreviousRoute ? {name: "default"} : {...routeFrom}
                );
            },
        },
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("./views/account/register"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (Cookies.get("token")) {
                    // Redirect to the home page instead
                    next({name: "default"});
                } else {
                    // Continue to the register page
                    next();
                }
            },
        },
    },
    {
        path: "/users",
        name: "users",
        meta: {
            authRequired: true,
            adminRequired: true,

        },
        component: () => import("./views/users/default"),
    },
    {
        path: "/contracts",
        name: "contracts",
        meta: {
            adminRequired: true,
            userRequired: true,
            authRequired: true,
        },
        component: () => import("./views/contracts/default"),
        props: true
    },
    {
        path: "/contracts/:contractId",
        name: "contractDetail",

        meta: {
            adminRequired: true,
            authRequired: true,
            userRequired: true,


        },
        component: () => import("./views/contracts/detail"),
    },
    {
        path: "/customers",
        name: "customers",
        meta: {
            authRequired: true,
            adminRequired: true,
            userRequired: true
        },
        component: () => import("./views/customers/default"),
    },
    {
        path: "/customers/:customerId",
        name: "customerDetail",
        meta: {
            authRequired: true,
            adminRequired: true,
            userRequired: true
        },
        component: () => import("./views/customers/detail"),
    },
    {
        path: "/persons",
        name: "default",
        meta: {
            authRequired: true,
            adminRequired: true
        },
        component: () => import("./views/persons/default"),
    },
    {
        path: "/person-groups",
        name: "default",
        meta: {
            authRequired: true,
            adminRequired: true
        },
        component: () => import("./views/personGroups/default"),
    },
    {
        path: "/products",
        name: "products",
        meta: {
            authRequired: true,
            adminRequired: true
        },
        component: () => import("./views/products/default"),
    },
    {
        path: "/products/:productId",
        name: "productDetail",
        meta: {
            authRequired: true,
            adminRequired: true
        },
        component: () => import("./views/products/detail"),
    },
    {
        path: "/sms",
        name: "sms",
        meta: {
            authRequired: true,
            userRequired: true,
            adminRequired: true
        },
        component: () => import("./views/sms/default"),
    },
    {
        path: "/settings",
        name: "settings",
        meta: {
            authRequired: true,
            adminRequired: true
        },
        component: () => import("./views/settings/default"),
    },
    {
        path: "/password-change",
        name: "passwordChange",
        meta: {
            authRequired: true,
            adminRequired: true,
            userRequired: true,
            lmsRequired: true
        },
        component: () => import("./views/passwordChange/default"),
    },
    {
        path: "/sms-templates",
        name: "smsTemplates",
        meta: {
            authRequired: true,
            adminRequired: true
        },
        component: () => import("./views/sms/smsTemplates"),
    }, {
        path: "/sms-logs",
        name: "smsLogs",
        meta: {
            authRequired: true,
            adminRequired: true
        },
        component: () => import("./views/sms/smsLogs"),
    },
    {
        path: "/salesReports",
        name: "salesReports",
        meta: {
            authRequired: true,
            adminRequired: true
        },
        component: () => import("./views/reports/salesReport"),
    },
    {
        path: "/paymentReports",
        name: "paymentReports",
        meta: {
            authRequired: true,
            adminRequired: true
        },
        component: () => import("./views/reports/paymentReport"),
    },
    {
        path: "/full-reports",
        name: "fullReports",
        meta: {
            authRequired: true,
            adminRequired: true
        },
        component: () => import("./views/reports/fullReport"),
    },
    {
        path: "/delayedInstallmentReports",
        name: "delayedInstallmentReports",
        meta: {
            authRequired: true,
            adminRequired: true
        },
        component: () => import("./views/reports/delayedInstallmentReport"),
    },



    {
        path: "/sites",
        name: "sites",
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true,
        },
        component: () => import("./views/sites/default"),
    }, {
        path: "/levels",
        name: "levels",
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true,
        },
        component: () => import("./views/levels/default"),
    }, {
        path: "/educations",
        name: "educations",
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true,
        },
        component: () => import("./views/educations/default"),
    }, {
        path: "/courses",
        name: "courses",
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true,
        },
        component: () => import("./views/courses/default"),
        props: true,
    },

    {
        path: '/courses/:courseId',
        name: 'courseDetail',
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true,
        },
        component: () => import("./views/courses/detail"),
        props: (route) => ({
            courseId: route.params.courseId,
            examId: route.query.examId,
            contentId: route.query.contentId,
            sectionId: route.query.sectionId,
        }),
    },



    {
        path: "/courses/:courseId/exams/:examId/questions",
        name: "examDetail",
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true,
        },
        component: () => import("./views/courses/detail2"),
        props: (route) => ({
            courseId: route.params.courseId,
            examId: route.query.examId,
            contentId: route.query.contentId,
        }),
    },

    {
        path: "/customerUsers",
        name: "customerUsers",
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true,
        },
        component: () => import("./views/customerUsers/default"),
        props: true,
    },
    {
        path: "/customerUsers/:customerUserId",
        name: "customerUserDetail",
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true,
        },
        component: () => import("./views/customerUsers/detail"),
        props: (route) => ({
            courseId: route.params.courseId,
            customerUserId: route.params.customerUserId,
        }),
    },

    {
        path: "/contents",
        name: "contents",
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true
        },
        component: () => import("./views/contents/default"),
    }, {
        path: "/advisors",
        name: "advisors",
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true
        },
        component: () => import("./views/advisors/default"),
    },{
        path: "/sales",
        name: "sales",
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true
        },
        component: () => import("./views/sales/default"),
    }, {
        path: "/campaigns",
        name: "campaigns",
        meta: {
            authRequired: true,
            adminRequired: true,
            lmsRequired: true
        },
        component: () => import("./views/campaigns/default"),
    },
    {
        path: "/bank-payments",
        name: "bankPayments",
        meta: {
            authRequired: true,
            adminRequired: true,
            userRequired: true
        },
        component: () => import("./views/bankPayments/default"),
    },
    {
        path: '/404',
        name: '404',
        component: require('./views/utility/404').default,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
        path: '*',
        redirect: '404',
    },

]
